
import { Injectable } from '@angular/core';
import { Action } from '../../../section/master/model/action';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { HttpClientService } from '../../../shared/service/http/http-client.service';
import { CookiesService } from '../../../shared/service/cookies/cookies.service';
@Injectable()
export class VideoLibraryService {
    http: HttpClientService;
    cookie: CookiesService;
    objAction: Action;
    constructor(http: HttpClientService, cook: CookiesService) {
        this.http = http;
        this.cookie = cook;
        this.objAction = new Action(this.http, this.cookie);
    }

    getVideoToken(id: string): Observable<any> {
        this.objAction.path = 'api/Users/VideoConferenceToken?orderId=' + id;
        return this.objAction.get();
    }

    sendNotificationToPatient(id: string, appId: number, roomId: string): Observable<any> {
        this.objAction.header = null;
        this.objAction.data = {'OrderId' : id, 'AppointmentId': appId, 'RoomId': roomId};
        this.objAction.path = 'api/Users/SendNotificationToPatient';
        return this.objAction.save();
    }

    updateDoctorJoiningStatus(id: string): Observable<any> {
        this.objAction.header = null;
        this.objAction.data = {'OrderId' : id};
        this.objAction.path = 'api/Appointment/UpdateDoctorJoiningStatus';
        return this.objAction.update();
    }

    updateDoctorDisconnectStatus(id: string): Observable<any> {
        this.objAction.header = null;
        this.objAction.data = {'OrderId' : id};
        this.objAction.path = 'api/Appointment/UpdateDoctorDisconnectStatus';
        return this.objAction.update();
    }
}



// WEBPACK FOOTER //
// ./src/app/section/video/service/video-library.service.ts